<template>
    <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="progressbar" :class="roundedString" :style="wrapperStyle">
        <div class="progressbar__background" :class="colorString ? `bg-${colorString} border-${colorString}` : ''" :style="{backgroundColor: colorHex, borderColor: colorHex}"/>
        <div class="progressbar__buffer"/>
        <div v-if="value === false" class="progressbar__runner">
            <div class="progressbar__runner-long" :class="colorString ? `bg-${colorString} border-${colorString}` : ''" :style="{backgroundColor: colorHex, borderColor: colorHex}"/>
            <div class="progressbar__runner-short" :class="colorString ? `bg-${colorString} border-${colorString}` : ''" :style="{backgroundColor: colorHex, borderColor: colorHex}"/>
        </div>
        <div v-else class="progressbar__value-bar h-full" :class="colorString ? `bg-${colorString}` : ''" :style="{width: value + '%', backgroundColor: colorHex}"/>
        <slot/>
    </div>
</template>

<script>
import {formatDimension} from "@spoferan/spoferan-ts-core";
    import Positionable from "../../mixins/Positionable";
    import Colorable from "../../mixins/Colorable";
    import Roundable from "../../mixins/Roundable";

    export default {
        name: "ProgressBar",

        mixins: [Positionable, Colorable, Roundable],

        props: {
            height: {
                type: [String, Number],
                default: 2
            },

            absolute: {
                type: Boolean,
                default: false
            },

            // When a value is set, the progress bar will have this value as fixed width
            value: {
                type: [Boolean, Number],
                default: false
            },

            color: {
                default: 'primary'
            },
        },

        computed: {
            wrapperStyle() {
                let style = {
                    position: this.absolute ? 'absolute' : 'relative',
                    left: this.left ? '0' : null,
                    right: this.right ? '0' : null,
                    bottom: this.bottom ? '0' : null,
                    top: this.top ? '0' : null,
                    height: formatDimension(this.height)
                };

                if (this.bottom) {
                    style.bottom = '0';
                    style.left = !this.right ? '0' : null;
                    style.right = this.right ? '0' : null;
                } else if (this.top) {
                    style.top = '0';
                    style.left = !this.right ? '0' : null;
                    style.right = this.right ? '0' : null;
                } else if (this.left) {
                    style.left = '0';
                    style.top = !this.bottom ? '0' : null;
                    style.bottom = this.bottom ? '0' : null;
                } else if (this.right) {
                    style.right = '0';
                    style.top = !this.bottom ? '0' : null;
                    style.bottom = this.bottom ? '0' : null;
                }

                return style
            }
        }
    }
</script>

<style>
.progressbar {
  overflow: hidden;
  background: transparent;
  position: relative;
  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
}
.progressbar .progressbar__background {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  transition: inherit;
  opacity: 0.3;
  width: 100%;
}
.progressbar .progressbar__buffer {
  height: inherit;
  left: 0;
  position: absolute;
  top: 0;
  transition: inherit;
  width: 100%;
  z-index: 1;
}
.progressbar .progressbar__runner > div {
  background-color: inherit;
  bottom: 0;
  height: inherit;
  left: 0;
  position: absolute;
  top: 0;
  width: auto;
  will-change: left, right;
}
.progressbar .progressbar__runner > div.progressbar__runner-long {
  animation: indeterminate;
  animation-duration: 2.2s;
  animation-iteration-count: infinite;
}
.progressbar .progressbar__runner > div.progressbar__runner-short {
  animation: indeterminate-short;
  animation-duration: 2.2s;
  animation-iteration-count: infinite;
}
@keyframes indeterminate {
  0% {
    left: -90%;
    right: 100%;
  }
  60% {
    left: -90%;
    right: 100%;
  }
  100% {
    left: 100%;
    right: -35%;
  }
}
@keyframes indeterminate-short {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}
</style>